// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5950":"50f819bab24b2cd8fbe8","6887":"34713010488cefbf14ba","9462":"f8f99f3e8e2a4a6fb6f4"}[chunkId] + ".chunk.css";
};